import { Icon, Tooltip } from '@genial/components';
import { Box, Pressable } from 'native-base';
import React from 'react';

import {
  TableContent,
  TableContentItemColumn,
  TableContentItemText,
} from '../../../../../../../../../components/TableContent';
import { useGlobalAssetContext } from '../../../../../contexts';
import { useClubsAssetContext } from '../../../../../contexts/products/Clubs';
import { LateralBar } from '../../../components/LateralBar';
import { clubsConstants } from '../constants';
import { ListLoadingItemDesktop } from '../ListLoadingItem/desktop';

import { ClubsItemTypes } from '.';

export const ClubsItemDesktop: React.FC<ClubsItemTypes.Props> = ({ offer }) => {
  const { setModalOpen, setOfferSelected } = useClubsAssetContext();
  const { infoGetter, selectedTab, accountId } = useGlobalAssetContext();

  const { Button, isSelected, forceLoading } = infoGetter('clubs', offer, 'clubId');

  const onOpenDetailsModal = () => {
    setModalOpen(true);
    setOfferSelected({ ...offer, accountId: accountId || 0 });
  };

  const getFlex = (index: number) => {
    const currentHead = clubsConstants.tableHead.find((_, i) => i === index);
    return currentHead?.flex || 1;
  };

  if (forceLoading) {
    return <ListLoadingItemDesktop />;
  }

  return (
    <TableContent
      direction="row"
      space={0}
      p={0}
      px="inline.xxxs"
      h="80px"
      isHighlighted={isSelected}>
      <LateralBar
        backgroundColor={selectedTab.color}
        borderTopLeftRadius="sm"
        borderBottomLeftRadius="sm"
      />
      <TableContentItemColumn flex={getFlex(0)}>
        <Tooltip testID="details-tooltip" label="Ver detalhes">
          <Pressable onPress={onOpenDetailsModal}>
            <Icon name="Info" size="xs" />
          </Pressable>
        </Tooltip>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(1)}>
        <TableContentItemText>{offer.managerNameNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(2)}>
        <TableContentItemText>{offer.clubNameNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(3)}>
        <TableContentItemText>{offer.minimumApplicationNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(4)}>
        <TableContentItemText>{offer.cutoffTimeNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(5)}>
        <Box w="100%">
          <Button
            id={selectedTab.typeGetterId}
            offer={offer}
            productContextConstant={selectedTab}
          />
        </Box>
      </TableContentItemColumn>
    </TableContent>
  );
};
